import $ from 'jquery';

class AccessibleMenu {
    constructor() {
        this.$ = $;
        this.$link = $('.c-main-menu__list > .c-main-menu__list-item > .c-main-menu__list-item-wrapper > .c-main-menu__link');
        this.addFocusClass();
    }

    addFocusClass() {
        this.$link.each((i, e) => {
            const $link = $(e);
            // If top menu link next sibling is a sub menu then do the following
            if ($link.parent().next().is('.js-sub-menu')) {
                // When top menu item is focused on
                $link.on('focus', () => {
                    // Add focus class to the container of the link and the sub menu i.e. to the <li>
                    $($link).parent().parent().addClass('focus');
                });

                // Define submenu in a variable
                const $subMenu = $link.parent().next();
                // Define submenu links in a variable
                const $subMenuLinks = $subMenu.find('a');
                // Get index of last item of submenu
                const lastLinkIndex = $subMenuLinks.length - 1;
                const $lastLink = $subMenuLinks.eq(lastLinkIndex);

                // Event listener that will remove the focus class from container when the last link from submenu loses focus
                $lastLink.on('blur', () => {
                    $link.parent().parent().removeClass('focus');
                });
            }
        });
    }
}

export default AccessibleMenu;
